import { SimpleGrid, type SimpleGridProps } from '@chakra-ui/react';

export type UiSimpleGridProps = SimpleGridProps;

export const UiSimpleGrid = SimpleGrid;
